export default __webpack_public_path__ + "static/media/335c5678bd6b15f3834467b6e6f58d0de122b330139c690973793133e6671d71.db4fb4ba.svg";